import _ from 'lodash';
import { formatDaysToDaysAndHours } from '../../../settings/views/Notifications/notifications.service';

const parseTitleWithNumericValue = (humanValue, oldValue) => {
  // "pull_request_created_age_in_human_readable_format" is a new field that the event dispatcher add to payload
  // On old notifications (PR Here) we must use the old value field
  try {
    return humanValue && humanValue.trim() !== '' ? humanValue : oldValue;
  } catch (e) {}
  return oldValue;
};

export const notificationTypeConfig = {
  '01': {
    title: ({ code_changes_fmt }) =>
      `A pull request with ${code_changes_fmt} code changes was merged without review`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'merged_without_review_pr_size', 0) }
        : {
            value: _.get(thresholdsData, 'merged_without_review_threshold', 0)
          },
    goal: thresholdValues =>
      `Review all PRs with more than ${thresholdValues.value} code changes`
  },
  '02': {
    title: ({ rework_percentage, refactor_percentage, code_changes_fmt }) =>
      `A pull request has been merged containing ${code_changes_fmt} code changes with ${_.round(
        rework_percentage + refactor_percentage
      )}% refactor and rework`,
    headsUp: ({ rework_percentage, refactor_percentage, code_changes_fmt }) =>
      `Heads up: A pull request contains ${code_changes_fmt} code changes with ${_.round(
        rework_percentage + refactor_percentage
      )}% refactor and rework`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'rework_refactor_percentage', 0) }
        : {
            value: _.get(
              thresholdsData,
              'work_at_risk_rework_refactor_threshold',
              0
            )
          },
    goal: () => `Avoid merging pull requests with work at risk`,
    showOwner: true,
    pathFormat: (path, thresholdValues) =>
      path.replace('-None', `-${thresholdValues.value}`)
  },
  '03': {
    title: ({
      pull_request_created_age_in_human_readable_format,
      pull_request_created_age
    }) =>
      `A pull request that waited for review for ${parseTitleWithNumericValue(
        pull_request_created_age_in_human_readable_format,
        pull_request_created_age
      )} has been merged`,
    headsUp: ({
      pull_request_created_age_in_human_readable_format,
      pull_request_created_age
    }) =>
      `Heads up: A pull request has been waiting for review for ${parseTitleWithNumericValue(
        pull_request_created_age_in_human_readable_format,
        pull_request_created_age
      )}`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'hanging_age_in_days', 0) }
        : {
            value: _.get(thresholdsData, 'review_hanging_time_threshold', 0)
          },
    goal: thresholdValues =>
      `Start PR reviews within ${formatDaysToDaysAndHours(
        thresholdValues.value
      )}`
  },
  '05': {
    title: ({ pull_request_review_time }) =>
      `A pull request was merged after being reviewed for ${pull_request_review_time}`,
    headsUp: ({ pull_request_review_time }) =>
      `Heads up: A pull request has been under review for ${pull_request_review_time}`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'review_age_in_days', 0) }
        : {
            value: _.get(thresholdsData, 'review_too_long_time_threshold', 0)
          },
    goal: thresholdValues =>
      `Complete PR reviews in less than ${formatDaysToDaysAndHours(
        thresholdValues.value
      )}`,
    showOwner: true
  },
  '06': {
    title: ({ code_changes_fmt, pull_request_review_time }) =>
      `A pull request with ${code_changes_fmt} code changes was merged with basic review (${pull_request_review_time})`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? {
            value: _.get(thresholdsData, 'superficial_review_pr_size', 0),
            value1: _.get(thresholdsData, 'superficial_review_pr_age', 0)
          }
        : {
            value: _.get(thresholdsData, 'superficial_pr_size_threshold', 0),
            value1: _.get(
              thresholdsData,
              'superficial_review_time_threshold',
              0
            )
          },
    goal: thresholdValues =>
      `Avoid reviews shorter than ${thresholdValues.value1} minutes for PRs with more than ${thresholdValues.value} code changes`
  },
  '08': {
    title: ({ code_changes_fmt }) =>
      `A pull request has been merged with ${code_changes_fmt} code changes`,
    headsUp: ({ code_changes_fmt }) =>
      `Heads up: A pull request was opened with ${code_changes_fmt} code changes`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'pull_request_size_larger_than', 0) }
        : {
            value: _.get(thresholdsData, 'pull_request_size_goal', 0)
          },
    goal: thresholdValues =>
      `Limit PRs to ${thresholdValues.value} code changes or less`
  },
  '09': {
    title: ({
      pull_request_created_age_in_human_readable_format,
      pull_request_created_age
    }) =>
      `A pull request took ${parseTitleWithNumericValue(
        pull_request_created_age_in_human_readable_format,
        pull_request_created_age
      )} to be merged`,
    headsUp: ({
      pull_request_created_age_in_human_readable_format,
      pull_request_created_age
    }) =>
      `Heads up: A pull request has been open for ${parseTitleWithNumericValue(
        pull_request_created_age_in_human_readable_format,
        pull_request_created_age
      )}`,
    thresholdValues: ({ thresholdsData, isV2 }) =>
      isV2
        ? { value: _.get(thresholdsData, 'pr_age_in_days', 0) }
        : {
            value: _.get(thresholdsData, 'pull_request_open_time_goal', 0)
          },
    goal: thresholdValues =>
      `Merge PRs in ${formatDaysToDaysAndHours(thresholdValues.value)} or less`
  }
};
